import Vue from 'vue';
import Vuex from 'vuex';
import {AscDesc, ResultType, XHTTPService} from '@/shared/xhttp';
import {
	PaginatorFilterState,
	PaginatorActionWithFilters,
	PaginatorMutation,
	StandardAction,
} from '@/shared/utils';
import {Fournisseur, User} from '@/models';
import {FournisseurService} from '@/xhttp';

import {DateFilter} from '@/shared/filter';
import store from '@/stores';

Vue.use(Vuex);

export class FournisseurFilter {

	name: string = '';
	email: string = '';
	remarques: string = '';
	address: string = '';
	zipCode: string = '';
	town: string = '';
	country: string = '';

	public clear(): void {
		this.name = '';
		this.email = '';
		this.remarques = '';
		this.address = '';
		this.zipCode = '';
		this.town = '';
		this.country = '';
	}

	public toString(): string {
		return JSON.stringify(this);
	}
}

class FournisseurState extends PaginatorFilterState<FournisseurFilter> {
	fournisseur: Fournisseur = null;
	fournisseurs: ResultType<Fournisseur> = null;
	public constructor() {
		super(new FournisseurFilter(), 'fournisseurs', 'fournisseur', 'id', AscDesc.DESC, 20)
	}
}

class FournisseurStore {

	@XHTTPService(() => Fournisseur)
	private fournisseurService: FournisseurService;

	public state: FournisseurState = new FournisseurState();

	public mutations = {
		...PaginatorMutation(() => storeFournisseur, 'fournisseurs', 'fournisseur'),
	};

	public actions = {
		...StandardAction<Fournisseur, FournisseurState>(() => Fournisseur, 'fournisseur'),
		...PaginatorActionWithFilters<Fournisseur, FournisseurState>(() => Fournisseur, 'fournisseurs', 'fournisseur'),
	};

}

const instance = new FournisseurStore();
const storeFournisseur = new Vuex.Store(instance);
store.registerModule('fournisseur', storeFournisseur);
export default storeFournisseur;
